module.exports = __webpack_public_path__ + "static/media/logo-tekbnk.a2623b02.svg";